import Button from "@/common/components/Button";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListFilters from "@/common/components/ListFilters";
import Table from "@/common/components/Table";
import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker";
import { billingBillStatus } from "@/common/constants/statusBills.constants";
import { useFilterDate } from "@/common/hooks/useFilterDate";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { defaultColumns } from "@/features/establishments/constants/establishmentBillsColumns.constant";
import useEstablishmentBills from "@/features/establishments/hooks/useEstablishmentBills";
import { EstablishmentBillsTransformer } from "@/features/establishments/services/establishmentBillsTransformer";
import { EstablishmentBillData } from "@/features/establishments/types/establishmentBills.type";
import { Link, useParams } from "react-router-dom";

const List = () => {
  const { id } = useParams();

  const { filterParams, setFilterParams } = useFilterParams({
    status: billingBillStatus.find(({ value }) => value === 'pending_payment')
  });
  const { date, formattedDate } = useFilterDate(filterParams);

  const {
    data: bills,
    meta,
    isPending: establishmentBillsIsPending,
    isFetching: establishmentBillsIsFetching,
    error: establishmentBillsError = {} as any,
    refetch: refetchEstablishmentBills,
  } = useEstablishmentBills<EstablishmentBillData[]>({
    filters: {
      status: filterParams.status?.value,
      startDate: formattedDate.from,
      endDate: formattedDate.to,
      establishmentId: id,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<EstablishmentBillData[], any[]>({
      transformer: EstablishmentBillsTransformer.tableTransformer(),
    }),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={establishmentBillsError?.status}
      refetchFunction={refetchEstablishmentBills}
    >
      <div className="flex flex-col gap-6 h-[calc(100vh-192px)]">
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <DatePickerWithRange date={date} setDate={(date) => setFilterParams((prev) => ({ ...prev, date }))} />

            <ListFilters
              filters={[
                {
                  className: "w-56",
                  onChange: (status) => setFilterParams((prev) => ({ ...prev, status })),
                  value: filterParams.status,
                  options: [{ label: "Todas", value: "" }, ...(billingBillStatus || [])],
                  placeholder: "Status",
                  dataTestid: "filter_status",
                },
              ]}
            />
          </div>
          <div className="flex items-center gap-2">
            <Link
              to={establishmentBillsIsPending ? '' : `/establishments/${id}/bills/payment-advances`}
              className={establishmentBillsIsPending ? 'cursor-default' : ''}
            >
              <Button
                className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
                disabled={establishmentBillsIsPending}
              >
                Ver adiantamentos
              </Button>
            </Link>
          </div>
        </div>

        <div>
          <Table
            className="max-h-[calc(100vh-326px)]"
            columns={defaultColumns}
            isLoadingData={establishmentBillsIsFetching}
            rows={bills}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            page={filterParams.page || 1}
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </div>
    </ErrorMessageWrapper>
  );
};

export default List;
